// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__N_UfG","abort":"style_abort__3DGRk","submit":"style_submit__1wLgs"};